import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { EnvironmentService } from '@app/services/environment/environment.service';
import { UsercentricsService } from '@app/services/usercentrics/usercentrics';

const CONTENTSQUARE_SCRIPT_BASE_URL = 'https://t.contentsquare.net/uxa/';

/**
 * TODO(roadmap Phase 2): must match the name of the Data Processing Service added in the
 * Usercentrics admin (Service Settings → Data Processing Services) — it is not there yet, so
 * Contentsquare will never be considered consented-to until that DPS is added and published.
 */
const CONTENTSQUARE_CONSENT_SERVICE_NAME = 'Hotjar';

@Injectable({
  providedIn: 'root',
})
export class ContentsquareService {
  private readonly document = inject(DOCUMENT);
  private readonly platformId = inject(PLATFORM_ID);
  private readonly environmentService = inject(EnvironmentService);
  private readonly usercentricsService = inject(UsercentricsService);
  private isInitialized = false;

  /**
   * Loads Contentsquare only once the visitor has consented via Usercentrics (Phase 1), and keeps
   * watching consentChanged$ so a visitor who consents mid-session still gets it without
   * a page reload.
   */
  init(): void {
    const { tagId } = this.environmentService.contentsquare;

    if (!isPlatformBrowser(this.platformId) || this.isInitialized || !tagId) {
      return;
    }

    this.isInitialized = true;

    this.usercentricsService.whenConsented$(CONTENTSQUARE_CONSENT_SERVICE_NAME).subscribe(() => {
      this.appendScript(tagId);
    });
  }

  private appendScript(tagId: string): void {
    const script = this.document.createElement('script');
    script.async = true;
    script.src = `${CONTENTSQUARE_SCRIPT_BASE_URL}${tagId}.js`;
    this.document.head.appendChild(script);
  }
}
